document.addEventListener("click", function (e) {

  if (e.target.classList.contains("qty-plus")) {
    const input = e.target.parentElement.querySelector(".bp-product-card__qty");
    input.value = parseInt(input.value || 1) + 1;
  }

  if (e.target.classList.contains("qty-minus")) {
    const input = e.target.parentElement.querySelector(".bp-product-card__qty");
    const value = parseInt(input.value || 1);

    if (value > 1) {
      input.value = value - 1;
    }
  }
  });

